import React from 'react';
import { DefaultLayout } from './layouts/Default';
import { Pages } from './pages';
import { UserAuthContextProvider } from 'contexts/user-authentication';
import * as Sentry from "@sentry/react";
import { BrowserRouter } from 'react-router-dom';
import { ToastContextProvider } from 'contexts/toast';

export function App () {
  return (
    <Sentry.ErrorBoundary showDialog>
      <BrowserRouter>
        <UserAuthContextProvider>
          <ToastContextProvider>
            <DefaultLayout>
              <Pages />
            </DefaultLayout>
          </ToastContextProvider>
        </UserAuthContextProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}
